import React from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import {injectIntl} from 'react-intl';
import {
    FormGroup, FormControl, ControlLabel,
    Form, Row, Col, Checkbox, Button, ButtonToolbar, Alert
} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';


import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import {
    customerSegmentCardsAsHTMLOptions,
    valuePropositionCardsAsHTMLOptions,
    getCardsFromCustomerSegmentsHTMLSelectedOptions,
    getCardFromValuePropositionHTMLSelectedOption, getCardsAsHTMLOptions
} from './common/CardsSelectOptionsHelpers'
import ButtonWithConfirmation from "../common_components/ButtonWithConfirmation";
import AITextEditor from '../AITextEditor';

@observer
class ChannelsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: "",
            name: "",
            targetClientNumber: 0,
            purpose: "no_purpose",
            customerSegments: [],
            keyPropositions: [],
            description: "",
            attach_url: undefined,

            isEdition: false,
        };


        this.canDeleteCard = props.blockStore.rootStore.authorizationStore.canDeleteCard(props.blockStore.editingCard);

        this.renderSaveOrUpdateButton = this.renderSaveOrUpdateButton.bind(this);
        this.renderValuePropositionSelectOptions = this.renderValuePropositionSelectOptions.bind(this);
        this.renderCustomerSegmentsSelectOptions = this.renderCustomerSegmentsSelectOptions.bind(this);

        this.handleLabelChange = this.handleLabelChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleTargetClientNumberChange = this.handleTargetClientNumberChange.bind(this);
        this.handlePurposeChange = this.handlePurposeChange.bind(this);
        this.handleCustomerSegmentsChange = this.handleCustomerSegmentsChange.bind(this);
        this.handleValuePropositionChange = this.handleValuePropositionChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

    }

    render() {
        return (
            <div>
                {this.renderForm()}
            </div>
        );
    }

    renderForm() {
        const {blockStore, intl} = this.props;

        let cancelBtn;

        if (this.props.hideCancelBtn == null) {
            cancelBtn = <Button bsStyle="default" onClick={this.handleCancel}>
                {intl.formatMessage({id: "cancel"})}
            </Button>;
        } else {
            cancelBtn = <div></div>;
        }

        const labelValue = this.state.label.trim() ?
            intl.formatMessage({
                id: this.state.label,
                defaultMessage: " "
            }) : "";

        return (
            <div>

                {this.state.isEdition && (

                    <FormGroup
                        controlId="LabelChId"
                        validationState={this.validateLabel()}>
                        <Row>
                            <Col xs={12} sm={2}> {intl.formatMessage({id: "station"})} </Col>

                            <Col xs={12} sm={10}>
                                <FormControl
                                    type="text"
                                    value={labelValue}
                                    placeholder=""
                                    onChange={this.handleLabelChange}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                )}


                <FormGroup
                    controlId="NameChId"
                    validationState={this.validateName()}>
                    <Row>
                        <Col xs={12} sm={2}> <ControlLabel> {intl.formatMessage({id: "name"})} </ControlLabel> </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.name}
                                placeholder=""
                                onChange={this.handleNameChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="DescriptionChId" validationState={this.validateDescription()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <AITextEditor
                                value={this.state.description}
                                onChange={(value) => this.setState({description: value})}
                                context="El texto con el que estás trabajando es sobre la descripción de canales en un modelo de negocio Canvas. Los canales describen cómo una empresa se comunica y llega a sus segmentos de clientes para entregar su propuesta de valor. Incluye canales de distribución, venta, comunicación y puntos de contacto con el cliente."
                                rows={4}
                                placeholder=""
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="PurposeSelect">
                    <Row>
                        <Col xs={12} sm={2}><ControlLabel>{intl.formatMessage({id: "purpose"})}</ControlLabel></Col>
                        <Col xs={12} sm={10}>
                            <FormControl componentClass="select"
                                         placeholder="select"
                                         onChange={this.handlePurposeChange}
                                         value={this.state.purpose}
                            >
                                <option value="no_purpose">{intl.formatMessage({id: "select"})}</option>
                                <option value="awareness"> {intl.formatMessage({id: "awareness"})}</option>
                                <option value="evaluation"> {intl.formatMessage({id: "evaluation"})}</option>
                                <option value="purchase"> {intl.formatMessage({id: "purchase"})}</option>
                                <option value="delivery"> {intl.formatMessage({id: "delivery"})}</option>
                                <option value="after_sales"> {intl.formatMessage({id: "after-sales"})}</option>
                                <option value="data_collection"> {intl.formatMessage({id: "data_collection"})}</option>

                            </FormControl>
                        </Col>
                    </Row>
                </FormGroup>

                {this.renderValuePropositionSelect()}

                {this.renderCustomerSegmentsSelect()}

                <FormGroup
                    controlId="TargetClientNumeberChId"
                    validationState={this.validateTargetClientNumber()}>
                    <Row>
                        <Col xs={12} sm={4}>
                            <ControlLabel> {intl.formatMessage({id: "target-client-number"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={8}>
                            <FormControl
                                type="number"
                                step="1"
                                value={this.state.targetClientNumber}
                                placeholder=""
                                onChange={this.handleTargetClientNumberChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>


                <AttachmentsForm attachable={blockStore.editingCard}/>

                <br/>

                <ButtonToolbar className="pull-right">
                    {this.renderSaveOrUpdateButton()}

                    {this.state.isEdition && this.canDeleteCard && (
                        <ButtonWithConfirmation dropdownClassname="bmc-card-delete-button"
                                                confirmationMessage={intl.formatMessage({id: "delete_confirmation_msg"})}
                                                option1Label={intl.formatMessage({id: "delete_confirmation_no"})}
                                                option2Label={intl.formatMessage({id: "delete_confirmation_yes"})}
                                                onOption2Select={this.handleDelete}
                                                dropup>
                            {intl.formatMessage({id: "delete"})}
                        </ButtonWithConfirmation>
                    )}

                    {cancelBtn}
                </ButtonToolbar>

                <div className="clearfix"/>

            </div>
        );
    }


    renderCustomerSegmentsSelect() {
        //const {intl} = this.props;
        return (
            <FormGroup
                controlId="CustomerSegmentsSelectMultiple"
                validationState={this.validateCustomerSegments()}
            >
                <Row>
                    <Col xs={12} sm={4}>
                        <ControlLabel>  {this.props.intl.formatMessage({id: "IgbmcBoard-customer_segments"})}</ControlLabel>
                    </Col>
                    <Col xs={12} sm={8}>
                        <Select
                            onChange={this.handleCustomerSegmentsChange}
                            value={getCardsAsHTMLOptions(this.state.customerSegments)} multi
                            placeholder=""
                            options={this.renderCustomerSegmentsSelectOptions()}
                        />
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    renderValuePropositionSelect() {
        //const {intl} = this.props;
        return (
            <FormGroup
                controlId="ValuePropositionSelect"
                validationState={this.validateValueProposition()}
            >
                <Row>
                    <Col xs={12} sm={2}>
                        <ControlLabel>  {this.props.intl.formatMessage({id: "IgbmcBoard-key_propositions"})}</ControlLabel>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Select
                            multi
                            onChange={this.handleValuePropositionChange}
                            value={getCardsAsHTMLOptions(this.state.keyPropositions)}
                            placeholder=""
                            options={this.renderValuePropositionSelectOptions()}
                        />
                    </Col>
                </Row>

            </FormGroup>
        );
    }


    renderSaveOrUpdateButton() {

        if (this.state.isEdition) {
            return (
                <Button bsStyle="primary" onClick={this.handleUpdate}>
                    {this.props.intl.formatMessage({id: "save"})}
                </Button>
            )
        } else {
            const buttonMessage = this.props.blockStore.rootStore.stepByStepMode ? "save" : "add";

            return (
                <Button bsStyle="primary" onClick={this.handleSubmit}
                        disabled={!this.state.name && !this.state.description}>
                    {this.props.intl.formatMessage({id: buttonMessage})}
                </Button>
            )
        }


    }


    renderValuePropositionSelectOptions() {
        return valuePropositionCardsAsHTMLOptions(this.props.blockStore);
    }


    renderCustomerSegmentsSelectOptions() {
        return customerSegmentCardsAsHTMLOptions(this.props.blockStore);
    }


    handleLabelChange(e) {
        //this.setState({label: e.target.value});
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }


    handleTargetClientNumberChange(e) {
        this.setState({targetClientNumber: e.target.value});
    }

    handlePurposeChange(e) {
        this.setState({purpose: e.target.value});
    }

    handleCustomerSegmentsChange(value) {
        const cards = getCardsFromCustomerSegmentsHTMLSelectedOptions(this.props.blockStore, value);

        this.setState({customerSegments: cards});
    }

    handleValuePropositionChange(value) {

        const cards = getCardFromValuePropositionHTMLSelectedOption(this.props.blockStore, value);
        this.setState({keyPropositions: cards});
    }

    handleDescriptionChange(e) {

        this.setState({description: e.target.value});
    }


    validateLabel() {

    }

    validateName() {

    }


    validateTargetClientNumber() {

    }

    validatePurpose() {

    }

    validateCustomerSegments() {

    }

    validateValueProposition() {

    }

    validateDescription() {

    }

    @action
    handleSubmit() {
        const card = this.generateCardFromState();
        this.props.blockStore.addCard(card);
        this.props.blockStore.showBlockModal(false);

        this.resetForm();

    }


    @action
    handleCancel() {
        const {blockStore} = this.props;
        blockStore.hideBlockModal(true);


        this.resetForm();
    }

    @action
    handleUpdate() {
        this.generateCardFromState();

        const {blockStore} = this.props;

        if (blockStore.editingCard.persisted) {
            blockStore.editingCard.update();
            blockStore.showBlockModal(false);
        }
    }


    @action
    handleDelete() {
        this.props.blockStore.editingCard.destroy();
        this.props.blockStore.hideBlockModal(true);

    }


    generateCardFromState() {
        const {editingCard} = this.props.blockStore;

        editingCard.label = this.state.label;
        editingCard.name = this.state.name;
        editingCard.targetClientNumber = this.state.targetClientNumber;
        editingCard.purpose = this.state.purpose;
        editingCard.customerSegments = this.state.customerSegments;
        editingCard.keyPropositions = this.state.keyPropositions;
        editingCard.description = this.state.description;

        return editingCard;
    }

    resetForm() {
        this.setState({
            label: "",
            name: "",
            targetClientNumber: 0,
            purpose: "no_purpose",
            customerSegments: [],
            keyPropositions: [],
            description: "",
            attach_url: undefined,

            isEdition: false,

        });
    }


    componentDidMount() {
        this.initFields(this.props.blockStore.editingCard);
    }

    initFields(card) {
        this.setState({
            label: card.label,
            name: card.name,
            targetClientNumber: card.targetClientNumber,
            purpose: card.purpose,
            customerSegments: card.customerSegments,
            keyPropositions: card.keyPropositions,
            description: card.description,

            isEdition: card.persisted,

        });
    }


}

export default injectIntl(ChannelsForm);